<template>
  <div class="container">
    <div class="logo-wrapper">
      <i class="el-icon el-icon-ali-logo"></i>
    </div>
    <el-scrollbar :native="false" wrap-class="wrapper">
      <el-menu
        ref="menu"
        class="vertical"
        :collapse="sideBarFold"
        :default-active="$route.name"
        @select="handleSelect"
        background-color="#45326c"
        text-color="#fff"
        :router="true"
        :collapse-transition="true"
      >
        <el-menu-item index="taskAdmin" v-if="computedPermission('taskAdmin')">
          <i class="el-icon-ali-renwu el-icon"></i>
          <span slot="title">
            任务管理
            <el-badge
              :value="backDataUnCheckList.length + detectedUnCheckList.length"
              class="badge"
            >
            </el-badge>
          </span>
          <el-badge
            v-if="sideBarFold"
            :value="backDataUnCheckList.length + detectedUnCheckList.length"
            class="badge"
          >
          </el-badge>
        </el-menu-item>
        <el-menu-item
          index="taskHistory"
          v-if="computedPermission('taskHistory')"
        >
          <i class="el-icon-ali-lishi el-icon"></i>
          <span slot="title">
            任务历史
          </span>
        </el-menu-item>
        <el-submenu
          index="dishModel"
          v-if="computedPermission('dishModel')"
          default-active="dishModelManagement"
        >
          <template slot="title">
            <i class="el-icon-ali-wanju el-icon"></i>
            <span slot="title">碗碟管理</span>
            <!--<el-badge :value="unCheckListCount" class="badge"> </el-badge>-->
          </template>
          <el-menu-item
            index="dishModelManagement"
            v-if="computedPermission('dishModelManagement')"
          >
            <span slot="title">碗碟库管理</span>
          </el-menu-item>
          <el-menu-item
            index="bindCanteen"
            v-if="computedPermission('dishModelManagement')"
          >
            <span slot="title">餐厅碗碟库</span>
          </el-menu-item>
          <el-menu-item
            index="dishDataCheck"
            v-if="computedPermission('dishDataCheck')"
          >
            <span slot="title">数据清洗</span></el-menu-item
          >
        </el-submenu>
        <el-menu-item
          index="moduleAdmin"
          v-if="computedPermission('moduleAdmin')"
        >
          <i class="el-icon-ali-module el-icon"></i>
          <span slot="title">模块管理</span>
        </el-menu-item>
        <el-menu-item index="trainTask" v-if="computedPermission('trainTask')">
          <i class="el-icon-news"></i>
          <span slot="title">训练任务</span></el-menu-item
        >
        <!--<el-menu-item index="/trainModel" v-if="userGroup > 499">-->
        <!--<i class="el-icon-printer"></i>训练模型</el-menu-item-->
        <!--&gt;-->
        <el-menu-item
          index="batchUpload"
          v-if="computedPermission('batchUpload')"
        >
          <i class="el-icon-upload"></i>
          <span slot="title">批量上传</span>
        </el-menu-item>
        <el-menu-item
          index="backDataAccSummary"
          v-if="computedPermission('backDataAccSummary')"
          ><i class="el-icon-ali-shuimianxiaolv el-icon"></i
          ><span slot="title">回测准确率</span></el-menu-item
        >
        <el-menu-item
          index="regionsFix"
          v-if="computedPermission('regionsFix')"
        >
          <i class="el-icon-ali-xiugai el-icon"></i>
          <span slot="title">识别框校正</span>
        </el-menu-item>
        <el-menu-item
          index="canteenAdmin"
          v-if="computedPermission('canteenAdmin')"
        >
          <i class="el-icon-ali-navicon-ctsz el-icon"></i>
          <span slot="title">餐厅管理</span>
        </el-menu-item>
        <el-menu-item
          v-if="computedPermission('machineAdmin')"
          index="machineAdmin"
        >
          <i class="el-icon-setting"></i>
          <span slot="title">机器管理</span>
        </el-menu-item>
        <!--<el-tag type="success" v-if="environment">测试环境</el-tag>-->
        <el-menu-item
          index="eventManagement"
          v-if="computedPermission('eventManagement')"
        >
          <i class="el-icon-ali-event"></i>
          <span slot="title">事件管理</span>
        </el-menu-item>
        <el-menu-item index="ffi" v-if="computedPermission('ffi')">
          <i class="el-icon-ali-user"></i>
          <span slot="title">user_key管理</span>
        </el-menu-item>
        <el-menu-item index="userAdmin" v-if="computedPermission('userAdmin')">
          <i class="el-icon-ali-user"></i>
          <span slot="title">用户管理</span>
        </el-menu-item>
      </el-menu>
    </el-scrollbar>
    <div class="footer">
      <span v-show="!sideBarFold">Powered By </span>AeyeLab!
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {apiGetUserPermissions} from '@/api';

export default {
  name: "sideBar",
  components: {},
  data() {
    return {
      activeIndex: "",
      permission: []
    };
  },
  mounted() {
    this.getUserPermission();
  },
  methods: {
    ...mapMutations(["setSubTitle"]),
    async getUserPermission() {
      try {
        const res = await apiGetUserPermissions({ username: this.username });
        this.permission = res.permission;
      } catch (e) {
        this.$message.error("权限获取失败");
      }
    },
    handleSelect(key) {
      this.routeName = key;
      this.activeIndex = key;
      this.$router.push({
        name: key
      });
    },
    ...mapActions([]),
    computedPermission(idx) {
      if (this.userGroup === 1000) {
        return true;
      }
      return this.permission.indexOf(idx) !== -1;
    }
  },
  computed: {
    ...mapGetters([
      "userinfo",
      "detectedUnCheckList",
      "backDataUnCheckList",
      "sideBarFold"
    ]),
    username() {
      return this.userinfo().username;
    }
  },
  watch: {
    $route: {
      handler(val) {
        // console.log(val);
        this.activeIndex = val.name;
      }
    }
  }
};
</script>
<style lang="scss">
.el-scrollbar {
  .wrapper {
    max-height: calc(100vh - 30px - 64px);
  }
}
</style>
<style lang="scss" scoped>
.container {
  position: relative;
  background-color: #45326c;
  padding: 0;
  border: 0;
  .logo-wrapper {
    text-align: center;

    .el-icon-ali-logo {
      color: #fff;
      font-size: 64px;
    }
  }
  .vertical {
    border: 0;
    max-height: calc(100% - 30px);
    &:not(.el-menu--collapse) {
      width: 200px;
    }
    .badge {
      position: relative;
      top: -10px;
      right: 5px;
    }
  }
  .footer {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 0;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    color: #ccc;
  }
}
</style>
